import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formProducerSignupComplete_instructions: {
			fontSize: theme.typography.h6.fontSize,
			color: theme.palette.info.main,
		},
		formProducerSignupComplete_loginButton: {
			'& > button': {
				fontSize: theme.typography.h5.fontSize,
				textTransform: 'none',
				margin: theme.spacing(2),
				padding: theme.spacing(0, 2),
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					fontSize: theme.typography.h6.fontSize,
				},
			}
		},
	});
});

export default useStyles;
